import { createWidget } from '@typeform/embed';
import CurrentUser from '@frontend/app/features/CurrentUser';
import { runWhenDomLoaded } from '@frontend/utils/dom';

runWhenDomLoaded(() => {
  const typeformPlaceholder = Array.from(
    document.querySelectorAll('.js-typeform-placeholder')
  );
  let payload = {};
  if (CurrentUser.isLoggedIn()) {
    payload = {
      id: CurrentUser.id(),
      email: CurrentUser.email(),
      full_name: CurrentUser.fullName(),
      first_name: CurrentUser.firstName(),
      last_name: CurrentUser.lastName(),
    };
  }

  typeformPlaceholder.forEach((typeformPlaceholder) => {
    const typeformUid = typeformPlaceholder.dataset.typeformUid;

    createWidget(typeformUid, {
      container: typeformPlaceholder,
      width: '100%',
      hidden: payload,
      hideFooter: true,
      hideHeaders: false,
      inlineOnMobile: true,
      keepSession: true,
    });
  });
});
